
  import {Component, Ref, Vue} from "vue-property-decorator";
  import api from "@/api";
  import {UserCardDto, UserDto} from "@/api/appService";
  import moment from "moment";

    @Component({name:'UserDetail'})
    export default class UserDetail extends Vue{

      userDetailProfile: UserDto = {};

      userDiffCardBalance:number = 0;

      userCardDataItems:UserCardDto[] = [];
      userCardTable: any = {
        items: [],
        listLoading: true,
        pagesize: 50,
        page: 1,
        totalCount: 0,
        sorting: "id desc"
      };

      formatCard(userCard:UserCardDto){
        return userCard.card?.title;
      }

      formatCreationTime(value:any){
        return moment(value.creationTime).format('YYYY-MM-DD HH:mm:ss');
      }

      async created(){
        const id:number = parseInt(this.$route.params.id);
        await api.user.get({id:id}).then(res=>{
          this.userDetailProfile = res
        });
        this.fetchUserCardData();
        this.fetchUserDiffCardBalance();
      }

      private fetchUserDiffCardBalance(){
        api.userCard.getUserDiffCardBalance({userId:parseInt(this.$route.params.id)}).then(res=>{
          this.userDiffCardBalance = res;
        })
      }

      private fetchUserCardData(page = 1) {
        this.userCardTable.listLoading = true;
        const userId = parseInt(this.$route.params.id);

        api.userCard
          .getAll(Object.assign({
            sorting: this.userCardTable.sorting,
            skipCount: (page - 1) * this.userCardTable.pagesize,
            maxResultCount: this.userCardTable.pagesize
          },{
            userId: userId
          }))
          .then(response => {
            this.userCardTable.items = response.items;
            this.userCardTable.totalCount = response.totalCount;
            this.userCardTable.listLoading = false;
          });
      }
      // 切换切面,在watch中监听 page
      private userCardTableCurrentChange(e: any) {
        this.userCardTable.page = e;
        this.fetchUserCardData(e);
      }
      // 排序
      private sort(e: any) {
        console.log("sort : ", e);
        if (e.prop && e.order) {
          this.userCardTable.sorting = `${e.prop} ${e.order}`;
        } else {
          this.userCardTable.sorting = "id descending";
        }
        this.fetchUserCardData(1);
      }
      handleUserCardPageSizeChange(e: any) {
        this.userCardTable.pagesize = e;
        this.fetchUserCardData(1);
      }

    }
